import React from 'react'
import listObat from './listObat'

import { config } from '../Config/config'
import { Modal } from 'react-bootstrap'
import cariobatService from '../Service/cariobatService'

export default class modalSearch extends React.Component {

    cariobatModel = {
        name: "",
        price_max: "",
        price_min: "",
        indication: "",
        is_delete: false
    }

    constructor() {
        super()
        this.state = {
            List: [],
            showModal: false,
            Modal: this.cariobatModel,
            pencarian: {},
            errors: {},
            filter: {
                kategori: "",
                searchObat: "",
                segmen: "obat bebas",
                hargaMin: "",
                hargaMax: ""
            }
        }
    }

    loadList = async () => {
        const Filter = this.state.filter
        const respon = await cariobatService.getAllKategori(this.state.filter)


        var CariObat = [{ Filter }]
        localStorage.setItem(config.filter, JSON.stringify(CariObat))
        var filter2 = JSON.parse(localStorage.getItem(config.filter))
        console.log(filter2)
        if (respon.success) {
            this.setState({
                List: respon.result,
            })
        }
        console.log(this.state.List)
    }

    cariHandler = () => {
        if (this.handleValidation()) {
            localStorage.setItem(config.kategoriObat, this.state.filter.kategori)
            localStorage.setItem(config.searchObat, this.state.filter.searchObat)
            localStorage.setItem(config.segmen, this.state.filter.segmen)
            localStorage.setItem(config.hargaMin, this.state.filter.hargaMin)
            localStorage.setItem(config.hargaMax, this.state.filter.hargaMax)

            var hasilPencarian = []

            if (localStorage.getItem(config.kategoriObat).length > 0) {
                hasilPencarian.push("Kategori " + localStorage.getItem(config.kategoriObat))
            }

            if (localStorage.getItem(config.searchObat).length > 0) {
                hasilPencarian.push("Kata Kunci " + localStorage.getItem(config.searchObat))
            }

            if (localStorage.getItem(config.segmen).length > 0) {
                hasilPencarian.push("Hanya " + localStorage.getItem(config.segmen))
            }




            this.setState({
                pencarian: hasilPencarian.join(",")

            }, () => localStorage.setItem(config.hasilCariObat, this.state.pencarian))


            window.location = "/obat"
        }
    }



    componentDidMount() {
        this.loadList()
    }

    changeHandler = field => ({ target: { value } }) => {
        this.setState({
            Model: {
                ...this.state.Model,
                [field]: value
            }
        })
    }


    // checkedHandler = field => ({ target: { checked } }) => {
    //     this.setState({
    //         Model: {
    //             ...this.state.Model,
    //             [field]: checked
    //         }
    //     })
    // }

    // saveHandler = async () => {
    //     if (this.handleValidation()) {
    //         if (this.state.Mode == "Ubah") {
    //             const respon = await courierService.EditData(this.state.Model)
    //             if (respon.success) {
    //                 this.loadList()
    //                 this.setState({
    //                     Model: this.courierModel,
    //                     showModal: false
    //                 })
    //             }
    //         }
    //         else {
    //             const respon = await courierService.addData(this.state.Model)
    //             console.log(respon)
    //             if (respon.success) {
    //                 alert("Success Save Data")
    //                 this.loadList()
    //                 this.setState({
    //                     Model: this.courierModel,
    //                     showModal: false
    //                 })

    //             }
    //         }
    //     }
    // }


    filterHandler = field => ({ target: { value } }) => {
        this.setState({
            filter: {
                ...this.state.filter,
                [field]: value
            }
        })
    }

    resetField = () => {
        document.getElementById("search-field").reset();
        this.setState({
            filter: {
                kategori: "",
                searchObat: "",
                segmen: "obat bebas",
                hargaMin: "",
                hargaMax: ""
            }
        })
    }



    handleValidation() {
        let fields = this.state.filter
        let errors = {}
        let search = 0
        let formIsValid = true;

        // if (!fields["searchObat"]) {
        //     formIsValid = false
        //     errors["searchObat"] = "Search cannot be empty"
        // }


        if (fields["kategori"]) {
            search += 1
        }

        if (fields["searchObat"]) {
            search += 1
        }

        if (fields["hargaMin"]) {
            search += 1
        }
        if (fields["hargaMax"]) {
            search += 1
        }

        if (search==0) {
            formIsValid = false
            errors["searchObat"] = "Masukan minimal 1 kata kunci"
        }


        console.log(search)
        this.setState({ errors: errors })
        return formIsValid
    }




    render() {
        const { showModal, errors, List, Model } = this.state
        const { showModalCari, cancelModal } = this.props

        return (
            <div>
                {/* {JSON.stringify(this.state.Model)} */}
                <Modal show={showModalCari} onHide={cancelModal}>
                    <Modal.Header closeButton>
                        <Modal.Title>Cari Obat & Alat Kesehatan</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <form id="search-field">
                            <h5 class="mb-4">Masukan minimal 1 kata kunci untuk pencarian Anda</h5>
                            <div class="container">

                                <label class="form-label">Kategori</label>
                                <select class="form-control mb-4" onChange={this.filterHandler("kategori")}>
                                    <option selected hidden>---Pilih---</option>
                                    {
                                        List.map(data => {
                                            return (
                                                <option value={data.name}>{data.name}</option>
                                            )
                                        })
                                    }
                                </select>
                            </div>
                            <div class="mb-4">
                                <label class="form-label">Kata Kunci</label>
                                <input type="text" placeholder="nama obat atau indikasi" id="searchObat" class="form-control noArrow" onChange={this.filterHandler("searchObat")} />

                            </div>

                            <div class="mb-4">
                                <div class="radio">
                                    <label>
                                        <input type="radio" name="radio" value="obat bebas" onChange={this.filterHandler("segmen")} defaultChecked /> Hanya cari obat bebas (tanpa resep)
                            </label>
                                </div>
                                <div class="radio">
                                    <label>
                                        <input type="radio" name="radio" value="" onChange={this.filterHandler("segmen")} /> Cari semua obat (termasuk obat keras)
                            </label>
                                </div>
                            </div>

                            <label class="form-label">Harga</label>
                            <div class="row">
                                <div class="col">
                                    <input type="text" placeholder="Rp 0" class="form-control" id="hargaMin" onChange={this.filterHandler("hargaMin")} />

                                </div>
                                <div class="col text-center d-flex justify-content-center">
                                    sampai
                            </div>
                                <div class="col">
                                    <input type="text" placeholder="Rp 100.000.000" class="form-control noArrow" id="hargaMax" onChange={this.filterHandler("hargaMax")} />

                                </div>

                            </div>
                            <span className="error">{errors["searchObat"]}</span>
                        </form>
                    </Modal.Body>
                    <Modal.Footer>
                        <div class="text-center">
                            <button type="reset" value="Reset" class="btn btn-outline-primary" onClick={this.resetField}>Atur Ulang!</button>

                            <button type="button" class="btn btn-primary ml-2" onClick={this.cariHandler}>Cari</button>

                        </div>

                    </Modal.Footer>
                </Modal>

                <listObat
                    showModal={showModal}
                    pencarian={this.state.pencarian}
                />
            </div>
        )
    }
}